import { ConfirmationDialog } from '@/components/patterns/confirmation-dialog'
import { AdminHeaderActionButton } from '@/components/patterns/admin-page'
import { Badge } from '@/components/ui/badge'
import { Can } from '@/lib/casl'
import { PlayCircle } from 'lucide-react'

export default function WebsiteDesignActivationAction({
  activateDescription,
  activateTitle,
  disabled = false,
  isLive,
  isPending,
  onActivate,
  onOpenScheduledDesign,
  scheduledDesign = null,
}) {
  if (isLive) {
    return (
      <Badge variant="success" size="md" className="px-4 py-2">
        <PlayCircle className="fill-current" />
        Live now
      </Badge>
    )
  }

  const hasScheduledBlocker = Boolean(scheduledDesign?.id)
  const scheduledDesignName = scheduledDesign?.name || 'A scheduled design'

  return (
    <Can do="edit" on="designs">
      <ConfirmationDialog
        title={hasScheduledBlocker ? 'Scheduled design is live' : activateTitle}
        description={
          hasScheduledBlocker
            ? `${scheduledDesignName} is scheduled right now and is controlling your storefront. Manual activation is paused while that schedule is active.`
            : activateDescription
        }
        confirmText={hasScheduledBlocker ? 'Open Scheduled Design' : 'Activate Design'}
        pendingText="Activating..."
        isPending={!hasScheduledBlocker && isPending}
        onConfirm={hasScheduledBlocker ? onOpenScheduledDesign : onActivate}
        trigger={
          <AdminHeaderActionButton disabled={disabled || (!hasScheduledBlocker && isPending)}>
            <PlayCircle className="size-4" />
            {isPending && !hasScheduledBlocker ? 'Activating...' : 'Activate Now'}
          </AdminHeaderActionButton>
        }
      />
    </Can>
  )
}
